// Platform configs for the desktop share popover.
// Each entry knows how to build its intent URL from { url, title, summary }.
// Mobile uses the native Web Share API instead — see ShareButton.
//
// Messenger is intentionally absent from this list (requires a Facebook app_id);
// it shows up automatically in the mobile OS share sheet.
// Snapchat / Instagram / Messages have no public web intents — mobile-only.

const shareTargets = [
    {
        key: 'facebook',
        label: 'Facebook',
        icon: 'fa-brands fa-facebook',
        color: '#1877f2',
        build: ({ url }) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
    {
        key: 'twitter',
        label: 'X',
        icon: 'fa-brands fa-x-twitter',
        color: '#000000',
        build: ({ url, title }) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title || '')}`,
    },
    {
        key: 'whatsapp',
        label: 'WhatsApp',
        icon: 'fa-brands fa-whatsapp',
        color: '#25d366',
        build: ({ url, title }) => `https://wa.me/?text=${encodeURIComponent(`${title || ''} ${url}`.trim())}`,
    },
    {
        key: 'linkedin',
        label: 'LinkedIn',
        icon: 'fa-brands fa-linkedin',
        color: '#0a66c2',
        build: ({ url }) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    },
    {
        key: 'email',
        label: 'Email',
        icon: 'fa-regular fa-envelope',
        color: '#6c757d',
        build: ({ url, title, summary }) => `mailto:?subject=${encodeURIComponent(title || '')}&body=${encodeURIComponent(`${summary || ''}\n\n${url}`)}`,
    },
];

// Content types with backend share routes. ShareButton renders nothing for any other type.
const SUPPORTED_TYPES = ['article', 'product', 'news', 'story', 'trophy', 'workout'];

// Types whose backend share page can land inside the feed (?target=feed).
// The feed only knows articles/news, so other types (e.g. product) get no
// target and the share page redirects to the object's own page instead.
const FEED_TARGET_TYPES = ['article', 'news'];

// Public share URL for a content object. The backend /share/<type>/<uuidv4>
// page carries the OG preview and redirects into the webapp (or the native app).
const shareUrlFor = (type, uuidv4) => {
    const { protocol, hostname, port } = window.location;
    const hostWithPort = `${hostname}${port ? `:${port}` : ''}`;
    const target = FEED_TARGET_TYPES.includes(type) ? '&target=feed' : '';
    return `${protocol}//${hostWithPort}/share/${type}/${uuidv4}?domain=${hostWithPort}${target}`;
};

export { shareTargets, SUPPORTED_TYPES, FEED_TARGET_TYPES, shareUrlFor };
export default shareTargets;
